import {Component, Input} from '@angular/core';

import {DetailField, DetailParams} from '../../../../shared';

import {CHACRASDETAIL_DEFAULT_FIELDS, ChacrasDetailParams} from '../../../models';

@Component({
  selector: 'app-chacra-detail',
  templateUrl: './chacra-detail.component.html',
  styleUrls: ['./chacra-detail.component.scss']
})
export class ChacraDetailComponent {
  fields: DetailField[] = null;
  detailParams: DetailParams = null;

  constructor() {
  }

  _params: ChacrasDetailParams = null;

  @Input()
  set params(value: ChacrasDetailParams) {
    this._params = value;
    if (!value) {
      return;
    }
    this.fields = value.fields || CHACRASDETAIL_DEFAULT_FIELDS;
    const rows = this.fields.map(f => ({
      label: f.label,
      value: value.chacra[f.name]
    }));
    this.detailParams = {
      rows
    };
  }

}
